export const getDisplayTaskName = (
  task: { taskName: string },
  rows: number,
): string => {
  const canOverflow = task.taskName.includes(' ');
  const maxChar = rows === 1 ? 20 : !canOverflow ? 20 : 40;

  return task.taskName.length > maxChar
    ? `${task.taskName.slice(0, maxChar)}...`
    : task.taskName;
};
